// extracted by mini-css-extract-plugin
export default {"font-renta":"MountersSignatures_font-renta__uo4ud","validationMessage":"MountersSignatures_validationMessage__OhsKI"};